export const slide1 = require('./slide1.png');
export const slide2 = require('./slide2.png');
export const slide3 = require('./slide3.png');
export const slide4 = require('./slide4.png');
export const slide5 = require('./slide5.png');